import request from "../utils/request";

// ─── 类型定义 ─────────────────────────────────────────────────────────────────

export interface RecommendedQuestion {
  ID: string;
  Question: string;
  IsEnabled: boolean;
  DisplayOrder: number;
  IsValid?: boolean;
  CreatedAt?: string;
  UpdatedAt?: string;
}
export interface detailResponse {
  Entity: RecommendedQuestion;
}
export interface SearchResponse {
  Count: number;
  Data: RecommendedQuestion[];
}

interface SearchResponseRaw {
  Count?: number;
  Data?: Array<
    Partial<RecommendedQuestion> & {
      RecommendedQuestion_Question?: string;
      RecommendedQuestion_IsEnabled?: boolean;
      RecommendedQuestion_DisplayOrder?: number;
      RecommendedQuestion_IsValid?: boolean;
      RecommendedQuestion_CreateTime?: string;
      RecommendedQuestion_UpdateTime?: string;
    }
  >;
}

function normalizeQuestion(
  item: SearchResponseRaw["Data"] extends Array<infer T> ? T : never,
): RecommendedQuestion {
  return {
    ID: String(item?.ID ?? ""),
    Question: item?.Question ?? item?.RecommendedQuestion_Question ?? "",
    IsEnabled: Boolean(item?.IsEnabled ?? item?.RecommendedQuestion_IsEnabled ?? false),
    DisplayOrder: Number(item?.DisplayOrder ?? item?.RecommendedQuestion_DisplayOrder ?? 0),
    IsValid: item?.IsValid ?? item?.RecommendedQuestion_IsValid,
    CreatedAt: item?.CreatedAt ?? item?.RecommendedQuestion_CreateTime,
    UpdatedAt: item?.UpdatedAt ?? item?.RecommendedQuestion_UpdateTime,
  };
}

// ─── API 方法 ─────────────────────────────────────────────────────────────────

/** 搜索推荐问题（支持关键词和状态筛选） */
export function searchQuestions(params?: { Question?: string; IsEnabled?: boolean }) {
  return request
    .post<SearchResponseRaw>("/project/recommendedquestion/searchrecommendedquestion", params ?? {})
    .then((res) => {
      const list = (res.data?.Data ?? []).map(normalizeQuestion);
      return {
        ...res,
        data: {
          Count: res.data?.Count ?? list.length,
          Data: list,
        } satisfies SearchResponse,
      };
    });
}

/** 获取单条推荐问题详情 */
export function getQuestion(id: string) {
  return request.get<detailResponse>(`/project/recommendedquestion/${id}`);
}

/** 创建推荐问题 */
export function createQuestion(data: { Question: string; IsEnabled: boolean }) {
  return request.post("/project/recommendedquestion/create", {
    Entity: data,
  });
}

/** 编辑推荐问题 */
export function editQuestion(data: { ID: string; Question: string; IsEnabled: boolean }) {
  return request.put("/project/recommendedquestion/edit", {
    Entity: data,
  });
}

/** 批量删除推荐问题 */
export function batchDeleteQuestions(ids: string[]) {
  return request.post<number>("/project/recommendedquestion/batchdelete", ids);
}

/** 重新排序推荐问题 */
export function reorderQuestions(ids: string[]) {
  return request.post("/project/recommendedquestion/reorder", { ids });
}

/** 获取前台推荐问题（OpsMate 页面使用） */
export function getRecommendedQuestionsFront() {
  return request.get("/project/recommendedquestion/front").then((r) => r.data);
}
